import React from 'react';
import classNames from 'classnames';
import * as format from '../format';

require('./MultipleAvatars.scss');
/*多人组合头像组件 最多显示五人
属性：
assignes = [{
        "id": 107460817,
        "name": "anxuenan",
        "headPortrait": "",
        "color": "#ff7360"
    }
]
status = 1/2/3/4
3 头像置灰
cls 类
*/
class MultipleAvatars extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
        let avatars = Object.assign([], this.props.assignes);
        avatars = avatars.length > 5 ? avatars.slice(0,5) : avatars;
		return (
			<div className={classNames('multiple-avatars',this.props.cls)}>
                {this.props.status == 3 ? <div className="status-undo" /> : null}
                {avatars.map((p,index,array) => {
                    if(p.headPortrait) {
                        return (<img src={p.headPortrait} className={classNames('avatars-' + array.length,'rank-' + index)} key={p.id} />);
                    }
                    return (<div key={p.id} className={classNames('avatars-' + array.length,'rank-' + index)} style={{ 'backgroundColor': p['color'] }}>{format.subChineseStr(p.name,1)}</div>);
                })}
            </div>
	    );
	}
  }
export default MultipleAvatars;


// WEBPACK FOOTER //
// ./src/components/Approval/old/MultipleAvatars.js